<template>
  <div id="search-wrap">
    <v-layout wrap>
      <v-text-field
        v-model="modelSearch"
        ref="input"
        id="search-input"
        type="text"
        tabindex="0"
        class="ma-0 pt-0 search-input"
        outlined
        maxlength="40"
        autocomplete="off"
        placeholder="חפשו כל קטגוריה/ תחום..."
        background-color="#fff"
        color="primary"
        hide-details
        @keydown.enter="scrollToItem()"
      >
        <template v-slot:append>
          <v-icon class="icon-forma-1-copy-4" @click="scrollToItem()" />
        </template>
      </v-text-field>
    </v-layout>
    <p class="small red--text" v-if="this.foundElm.length > 0">
      נמצאו {{ this.foundElm.length }} תחומים
    </p>
    <p
      class="small red--text"
      v-if="this.foundElm.length === 0 && !!modelSearch"
    >
      לא נמצאו תחומים
    </p>
  </div>
</template>

<script>
// import $ from 'jquery';
 import { debounce } from 'lodash';

export default {
  components: {},
  props: {
    styles: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      modelSearch: null,
      foundElm: [],
      index: 0,
    };
  },
  mounted() {
    this.submitSearch = debounce(this.submitSearch, 500);

  },

  watch: {
    modelSearch() {
      if (this.modelSearch.length > 1) {
        this.submitSearch(this.modelSearch, this);
      } else {
        this.foundElm = [];
        this.index = 0;
        Array.from(document.querySelectorAll('.cat-list-item')).forEach(
          function (el) {
            el.classList.remove('highlight');
          }
        );
      }
    },
  },
  methods: {
    scrollToItem() {
      var el = document.querySelectorAll('.highlight')[this.index];

      if (this.foundElm.length === this.index) {
        this.index = 0;
        return false;
      } else {
        let y = 0;
        y = el.getBoundingClientRect().top + window.scrollY;
        window.scroll({
          top: y - 100,
          behavior: 'smooth',
        });
        this.index++;
      }
    },
    submitSearch(query) {
       // let categories = $('.cat-list-item')
      let categories = document.getElementsByClassName('cat-list-item');
      categories.forEach(function (cat, i){
        var category =
          document.getElementsByClassName('cat-list-item')[i].innerText;
        if (category.indexOf(query) > -1) {
          document
            .getElementsByClassName('cat-list-item')[i].classList.add('highlight');
        }
      });
      if (document.querySelectorAll('.highlight').length > 0) {
        this.foundElm = [...document.querySelectorAll('.highlight')];
      } else {
        this.foundElm = [];
        this.index = 0;
        //   categories.forEach(function (cat, i) {
        //     document
        //       .getElementsByClassName('cat-list-item')
        //       [i].classList.remove('highlight');

        // });

        // $('.cat-list-item').removeClass('highlight');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field input {
  font-size: 1.2em !important;
}

.search-res {
  height: 258px;
  object-fit: contain;
  border: solid 1px #d7d7d7;
  background-color: white;
}

#search-wrap {
  position: relative;
  max-width: 630px;
  margin: 0 auto;
}

#search-input-wrap #search-input {
  color: red !important;
}

.cat_btn {
  width: 95%;
  height: auto;
}

#my-scrollbar {
  width: 90%;
  max-height: 200px;
}

.scroll-me {
  min-width: 190px;
}

.vue-scrollbar__scrollbar-vertical {
  width: 5px !important;
}

#my-scrollbar .scrollbar {
  background: $primary;
}

#my-scrollbar .scrollbar {
  width: 5px !important;
  background: #f6f7f9;
}

#my-scrollbar .vue-scrollbar__scrollbar-vertical .scrollbar {
  width: 5px;
}

.icon-forma-1-copy-4 {
  height: 100%;
}

@media only screen and (min-width: 600px) {
  input#search-input.search-input {
    font-size: 24px !important;
  }

  #search-wrap {
    position: relative;
    max-width: 630px;
  }

  #search-input-wrap {
    border: 1px solid red;
    padding: 10px 5px;
  }
}
</style>
